import { render } from "./BankIconList.vue?vue&type=template&id=0b3a5130&scoped=true"
import script from "./BankIconList.vue?vue&type=script&lang=js"
export * from "./BankIconList.vue?vue&type=script&lang=js"

import "./BankIconList.vue?vue&type=style&index=0&id=0b3a5130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3a5130"]])

export default __exports__